import { normalizeISO, relativeISO } from "@/utils/datetime.js";

const withSubtext = dt => {
  if (!!dt) {
    let norm = normalizeISO(dt);
    const relative = relativeISO(dt);
    return `${norm}<small class="d-block text-light font-weight-light">${relative}<small>`;
  }
  return ''

};

export default {
  withSubtext
};
